import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';

import IconDrawer from '../IconDrawer/index';
import Button from '../../../../../../components/Button/index';

import './Drawer.css';
import intl from "react-intl-universal";

@inject("appStore")
@observer
class Drawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                maxHeight: 0,
                transition: 'all 1s ease',
            }
        };
    };

    transitionEnd = () => {
        if (!this.props.appStore.drawer.open) {
            this.props.appStore.setDrawer({open: true});
        }
    };
    // componentDidMount = () => {
    //     setTimeout(this.mountStyle, 10);
    // };
    // componentWillUnmount = () => {
    //     console.log('unmount')
    //     setTimeout(this.unMountStyle, 10);
    // };
    render() {
        return (
            <div key={this.props.questionType} className="Drawer">
                <div key={this.props.questionType} className="section">
                    <IconDrawer/>
                    <div className="closeButtonContainer">
                        <Button className="closeButton" onClick={() => this.props.appStore.setDrawer({open: false})}>
                            {intl.get("Landing.back_to_map")}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Drawer;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/components/Drawer/index.js